import VehiclesPage from './components/VehiclesPage';
import TravelHistoryDialog from './components/TravelHistoryDialog';

const routes = [
  {
    path: '/vehicle-registry',
    name: 'menu.vehicle.registry',
    icon: 'vehicles',
    customIcon: true,
    loginRequired: true,
    forAll: true,
    component: VehiclesPage,
    weight: 2,
    permission: [],
    children: [],
  },
  {
    path: '/vehicle-registry/travel-history',
    name: 'menu.vehicle.registry',
    icon: 'vehicles',
    customIcon: true,
    loginRequired: true,
    forAll: true,
    component: TravelHistoryDialog,
    weight: 2,
    permission: [],
    children: [],
    hideOnMenu: true,
  },
];

export default routes;
